export default function(data) {
    const form = new FormData()

    for (let key in data) {
        if (! Object.prototype.hasOwnProperty.call(data, key) || data[key] === null) continue

        if (data[key] instanceof Array) {
            data[key].forEach(e => {
                if (e !== null) {
                    form.append(key + '[]', e)
                }
            })
        } else {
            form.append(key, data[key])
        }
    }

    return form
}
